// extracted by mini-css-extract-plugin
export default {"header":"AppRouter__header--1B1","cookieLayer":"AppRouter__cookieLayer--1Bh","content":"AppRouter__content--21k"};